export const ROUTES = {
  ROOT: '/scheduler',
};

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments`;

export const ORDER_TYPES = {
  DAT: 'DAT',
  EXWORK: 'EXWORK',
  FORECAST: 'FORECAST',
};

export const REDUCER_NAME = 'SCHEDULER_SHIPMENTS';
